export default "__VITE_ASSET__D7r210d3__"